import React from 'react';

import GalleryItem from './GalleryItem';
import { customizeProducts } from '../customizeProducts';

const DesktopGallery = () => (
  <div className="select-slider mobile-hidden">
    {customizeProducts.map((prod) => (
      <GalleryItem
        key={prod.name}
        image={prod.image}
        name={prod.name}
        description={prod.description}
        customizeCampaign={prod.customizeCampaign}
      />
    ))}
  </div>
);

export default DesktopGallery;
